/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-30 13:37:13
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-14 17:46:40
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/TermsAndConditionEditor/Content/index.tsx
 */

import { SectionContent } from '@/src/layout/EditorPageLayout/EditorCollapsePageLayout';
import { getI18nFromGeneral } from '@/src/tools/tools';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Editor from 'src/constrains/BraftEditor';
import SectionHOC from 'src/pages/SalesCannelVersion/SalesChannelLegal/Components/HOC';
import {
  EnumCollapseId,
  getCollapse,
  getContent,
  onCollapseChange,
  onContentChange,
} from 'src/pages/SalesCannelVersion/SalesChannelLegal/TermsAndConditionEditor/slice';
import { generateErrorKey } from 'src/tools/helper';
import { tacPermissions } from '../../Components/hooks/permission';
import css from './css.module.less';

const configFront = ['undo', 'redo', 'separator', 'bold', 'code'];
const configBack = ['separator', 'code'];
const Content = (props: any) => {
  const _data: any = useSelector(getContent());
  const _editor = React.useRef<any>(null);
  const p: any = useParams();
  const { uuid } = p;
  const { canEdit } = tacPermissions(uuid);
  const _d = useDispatch();
  const {
    content: _content,
    loaded,
    //isNameDuplicate
  } = _data || {};
  const { content } = _content || {};

  React.useEffect(() => {
    if (loaded && _editor.current && _editor.current.setData) {
      _editor.current.setData(content);
    }
  }, [loaded]);
  const contentErr = _content[generateErrorKey('content')];
  const handleOnContentChange = ({ data, isEmpty }) => {
    _d(onContentChange({ content: data, isEmpty }));
  };
  return (
    <SectionContent className={css.container}>
      <Editor
        linkSet={props.linkSet}
        ref={(e) => (_editor.current = e)}
        id='SalesChannelLegalPageTermsAndConditionEditorContent'
        err={contentErr}
        data={content}
        onChange={handleOnContentChange}
        configFront={configFront}
        configBack={configBack}
        disabled={!canEdit || props?.disabled}
      />
    </SectionContent>
  );
};

export default SectionHOC(Content, {
  id: EnumCollapseId.Content,
  title: getI18nFromGeneral('general.sider.content'),
  getCollapse,
  onCollapseChange,
});
